import {
  LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST,
  LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS,
  LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE,
  DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST,
  DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS,
  DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE,
  DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST,
  DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS,
  DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE,
  EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST,
  EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS,
  EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE,
  FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST,
  FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS,
  FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE,
  DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST,
  DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS,
  DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE
} from '../../constants/import-examination-results'

const initialState = {
  listImportExaminationResult: [],
  listDetailImportExaminationResult: [],
  detailImportExaminationResult: {},
  loading: false,
  loadingImport: false,
  loadingExport: false,
  loadingDownloadTemplate: false,
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const resendOrderLisReducer = (state = initialState, action) => {
  switch (action.type) {
    case FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST:
      return {
        ...state,
        loadingImport: true
      }
    case FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS:
      return {
        ...state,
        loadingImport: false,
        error: null
      }
    case FILE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE:
      return {
        ...state,
        loadingImport: false,
        error: action.payload
      }

    case LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST:
      return {
        ...state,
        loading: true
      }
    case LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        listImportExaminationResult: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST:
      return {
        ...state,
        loading: true
      }
    case DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS:
      return {
        ...state,
        loading: false,
        listDetailImportExaminationResult: action.payload,
        pageable: action.pageable,
        error: null
      }
    case DETAIL_LIST_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST:
      return {
        ...state,
        loadingDetail: true
      }
    case DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS:
      return {
        ...state,
        loadingDetail: false,
        detailImportExaminationResult: action.payload,
        error: null
      }
    case DETAIL_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST:
      return {
        ...state,
        loadingExport: true
      }
    case EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS:
      return {
        ...state,
        loadingExport: false,
        error: null
      }
    case EXPORT_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE:
      return {
        ...state,
        loadingExport: false,
        error: action.payload
      }
    case DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_REQUEST:
      return {
        ...state,
        loadingDownloadTemplate: true
      }

    case DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_SUCCESS:
      return {
        ...state,
        loadingDownloadTemplate: false,
        error: null
      }

    case DOWNLOAD_TEMPLATE_IMPORT_EXAMINATION_RESULT_AND_RESUME_FAILURE:
      return {
        ...state,
        loadingDownloadTemplate: false,
        error: action.payload
      }
    default:
      return state
  }
}

export default resendOrderLisReducer
